import { createAction, Dispatch } from '@reduxjs/toolkit';
import {
  ApiEndpointSetting,
  ExternalMeasurementTagSettings,
  FormAuthenticatedData,
  ReCaptchaSetting,
  TrackingSetting,
  FileUploadSetting,
  FormAccessReportSetting,
} from 'backend';
import { useDispatch } from 'react-redux';
import { FormPage, InputData } from 'shared';
import { GlobalErrors } from '../../models';
import { CurrentPageState } from '../currentPageState';

const UPDATE_PAGE = 'commons/updatePage';

type UpdatePagePayload = {
  nextFormPage: FormPage;
  inputData: InputData;
  nextPageState?: CurrentPageState;
  reCaptchaSetting?: ReCaptchaSetting;
  trackingSetting?: TrackingSetting;
  authentication?: FormAuthenticatedData;
  needsScrollTopAndFocus?: boolean;
  globalErrors?: GlobalErrors;
  externalMeasurementTag?: ExternalMeasurementTagSettings;
  apiEndpoint: ApiEndpointSetting;
  fileUploadSetting?: FileUploadSetting;
  accessReportSetting?: FormAccessReportSetting;
};

export const updatePage = createAction<UpdatePagePayload, typeof UPDATE_PAGE>(
  UPDATE_PAGE,
);

export type UpdatePageAction = ReturnType<typeof updatePage>;

// dispatch
export const useUpdatePageDispatch = (): Dispatch<UpdatePageAction> =>
  useDispatch<Dispatch<UpdatePageAction>>();
